import { getCuration as getCurationApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetCurationServiceRequest, GetCurationServiceResponse } from './get-curation.dto';
import {
  GetCurationServiceRequestDtoSchema,
  GetCurationServiceResponseDtoSchema,
} from './get-curation.dto';

export const getCurationService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetCurationServiceRequestDtoSchema),
    async (request: GetCurationServiceRequest): Promise<GetCurationServiceResponse> => {
      const response = await getCurationApi(request);

      if (response.meta?.result === 'FAIL') {
        throw new Error(response.meta?.message ?? '큐레이터 상품 조회에 실패했습니다.');
      }

      return {
        curationId: response.data.curationId,
        title: response.data.title,
        description: response.data.description ?? '',
        type: response.data.type,
        ordNo: response.data.ordNo,
        goodsItems: response.data.goodsItems.map((item) => ({
          ...item,
          brandNo: item.brandNo ?? 0,
          goodsNo: item.goodsNo.toString(),
          // search/liked-products와 동일하게 nullish → boolean 정규화
          isExclusive: item.isExclusive ?? false,
        })),
        snapItems: response.data.snapItems ?? [],
      };
    },
    validateServiceResponse(GetCurationServiceResponseDtoSchema),
  ),
);
